import React from 'react';
import FieldAlert from './FieldAlert';
import { connect } from 'formik';

const FormErrors = ({ formik: { errors } }) =>
  errors.form && Array.isArray(errors.form.errors) ? (
    errors.form.errors.map((error, idx) => (
      <FieldAlert key={idx} message={error.detail} />
    ))
  ) : null

export default connect(FormErrors)



// WEBPACK FOOTER //
// ./src/components/form/FormErrors.js